import { createMigrate } from 'redux-persist';
import m0000 from './0000';

export default createMigrate({
  0: m0000,
});



// WEBPACK FOOTER //
// ./src/app/api/redux-watson/app-config/migrations/index.js